import instance from "../http";
import { getHeader } from "../../utils/utils";
import { authPath, userManagement } from "../../constants/path";

export async function getUserRoles(_listingPerPage = 10, _listingPage = 1, search = '', is_active = '', organisation_uuid) {
    const headers = getHeader();
    const response = await instance.get(
        userManagement.GET_USER_ROLES + `?perPage=${_listingPerPage}&page=${_listingPage}${search && `&search=${search}`}${is_active && `&is_active=${is_active}&organization_uuid=${organisation_uuid}`}`,
        headers
    );
    return response;
}

export async function getUsers(perPage = 10, page = 1, search = '', isAtive = '', organization_uuid) {
    const headers = getHeader();
    const response = await instance.get(
        userManagement.GET_USER_LIST + `?page=${page}&perPage=${perPage}&is_active=${isAtive}${search && `&search=${search}`}${organization_uuid && `&organization_uuid=${organization_uuid}`}`,
        headers
    );
    return response;
}

export async function addUserApi(formData) {
    const headers = getHeader();
    const response = await instance.post(userManagement.ADD_USER, formData, headers);
    return response;
}

export async function editUserApi(formData, userId) {
    const headers = getHeader();
    const response = await instance.put(userManagement.EDIT_USER + userId, formData, headers);
    return response;
}

export async function getParticularUser(userId, organization_uuid) {
    const headers = getHeader();
    const response = await instance.get(
        userManagement.GET_PARTICULAR_USER + userId + `${organization_uuid && `?organization_uuid=${organization_uuid}`}`,
        headers
    );
    return response;
}

export async function activateDeactivateUser(userId) {
    const headers = getHeader();
    const response = await instance.patch(
        userManagement.ACTIVATE_DEACTIVATE_USER + userId,
        "",
        headers
    );
    return response;
}

export async function deleteUserApi(userId, organization_uuid) {
    const headers = getHeader();
    const response = await instance.delete(
        userManagement.DELETE_USER + userId + `${organization_uuid && `?organization_uuid=${organization_uuid}`}`,
        headers
    );
    return response;
}

export async function userVerifyApi(values) {
    const headers = getHeader();
    const response = await instance.put(
        authPath.USER_VERIFY,
        values,
        headers
    );
    return response;
}